module.exports = __webpack_public_path__ + "static/media/news42.baa88820.jpg";